import { defineStore } from 'pinia';

interface SalesPersonFormMetaData {
  firstName: string;
  lastName: string;
  phone: string;
  imageUrl: string;
  employeeNumber: number;
}

export interface SisccSelection {
  amount: string;
  displayText: string;
  price: number;
  retailerId: string;
}

export interface FormMetaDataState {
  Brand: string;
  Model: string;
  DepartmentId: string;
  DepartmentName: string;
  RegistrationNumber: string;
  UniqueId: string;
  SisccConfig: string;
  SisccSelections: SisccSelection[];
  ActiveConfigurationGroupId: string;
  AdditionalInformation: string;
  IsTransportVehicleFallback: boolean;
  SalesPerson: SalesPersonFormMetaData | null;
}

export const initialState: () => FormMetaDataState = () => {
  return {
    Brand: '',
    Model: '',
    DepartmentId: '',
    DepartmentName: '',
    RegistrationNumber: '',
    UniqueId: '',
    SisccConfig: '',
    SisccSelections: [],
    ActiveConfigurationGroupId: '',
    AdditionalInformation: '',
    IsTransportVehicleFallback: false,
    SalesPerson: null,
  };
};

export const useFormMetaDataStore = defineStore('formMetaData', {
  state: initialState,
  getters: {
    brand: (state: FormMetaDataState): string => state.Brand,
    model: (state: FormMetaDataState): string => state.Model,
    departmentId: (state: FormMetaDataState): string => state.DepartmentId,
    departmentName: (state: FormMetaDataState): string => state.DepartmentName,
    registrationNumber: (state: FormMetaDataState): string => state.RegistrationNumber,
    uniqueId: (state: FormMetaDataState): string => state.UniqueId,
    sisccConfig: (state: FormMetaDataState): string => state.SisccConfig,
    sisccSelections: (state: FormMetaDataState): SisccSelection[] => state.SisccSelections,
    activeConfigurationGroupId: (state: FormMetaDataState): string => state.ActiveConfigurationGroupId,
    additionalInformation: (state: FormMetaDataState): string => state.AdditionalInformation,
    isTransportVehicleFallback: (state: FormMetaDataState): boolean => state.IsTransportVehicleFallback,
    salesPerson: (state: FormMetaDataState): SalesPersonFormMetaData | null => state.SalesPerson,
    formMetaData: (state: FormMetaDataState): FormMetaDataState => {
      return {
        Brand: state.Brand,
        Model: state.Model,
        DepartmentId: state.DepartmentId,
        DepartmentName: state.DepartmentName,
        RegistrationNumber: state.RegistrationNumber,
        UniqueId: state.UniqueId,
        SisccConfig: state.SisccConfig,
        SisccSelections: state.SisccSelections,
        ActiveConfigurationGroupId: state.ActiveConfigurationGroupId,
        AdditionalInformation: state.AdditionalInformation,
        IsTransportVehicleFallback: state.IsTransportVehicleFallback,
        SalesPerson: state.SalesPerson,
      };
    },
  },
  actions: {
    changeBrand(brand: string) {
      this.Brand = brand;
    },
    changeModel(model: string) {
      this.Model = model;
    },
    changeDepartmentId(departmentId: string) {
      this.DepartmentId = departmentId;
    },
    changeDepartmentName(departmentName: string) {
      this.DepartmentName = departmentName;
    },
    changeRegistrationNumber(registrationNumber: string) {
      this.RegistrationNumber = registrationNumber;
    },
    changeUniqueId(uniqueId: string) {
      this.UniqueId = uniqueId;
    },
    changeSisccConfig(sisccConfig: string) {
      this.SisccConfig = sisccConfig;
    },
    changeSisccSelections(sisccSelections: SisccSelection[]) {
      this.SisccSelections = sisccSelections;
    },
    changeActiveConfigurationGroupId(activeConfigurationGroupId: string) {
      this.ActiveConfigurationGroupId = activeConfigurationGroupId;
    },
    changeAdditionalInformation(additionalInformation: string) {
      this.AdditionalInformation = additionalInformation;
    },
    changeIsTransportVehicleFallback(isTransportVehicleFallback: boolean) {
      this.IsTransportVehicleFallback = isTransportVehicleFallback;
    },
    changeSalesPerson(salesPerson: SalesPersonFormMetaData | null) {
      this.SalesPerson = salesPerson;
    },
    resetState() {
      this.$reset();
    },
  },
});
